import React, { useEffect, useState } from "react";
import NormalSelect from "../HorizontalNormalSelect";

const datestyle = {
  textField: {
    size: "small",
    sx: {
      fontSize: 12,
      background: "white",
    },
    inputProps: {
      style: { fontSize: 12 },
    },
    InputLabelProps: {
      style: { fontSize: 12 },
    },
  },
  layout: {
    sx: {
      ".MuiPickersCalendarHeader-root": {
        display: "none",
      },
    },
  },
};

const days = new Array(31)
  .fill(null)
  .map((d, index) => ({ id: index, name: index + 1 }));

const months = [
  {
    id: 1,
    name: "January",
  },
  {
    id: 2,
    name: "February",
  },
  {
    id: 3,
    name: "March",
  },
  {
    id: 4,
    name: "April",
  },
  {
    id: 5,
    name: "May",
  },
  {
    id: 6,
    name: "June",
  },
  {
    id: 7,
    name: "July",
  },
  {
    id: 8,
    name: "August",
  },
  {
    id: 9,
    name: "September",
  },
  {
    id: 10,
    name: "October",
  },
  {
    id: 11,
    name: "November",
  },
  {
    id: 12,
    name: "December",
  },
];

const fromYear = new Date().getFullYear() - 40;
const years = new Array(41)
  .fill(null)
  .map((d, index) => ({ id: index, name: fromYear + index }));

export const DatepickerOpt = ({ onValueChange, defaultValue }) => {
  const [date, setDate] = useState({
    day: "",
    month: "",
    year: "",
  });

  const handleChange = (type, value) => {
    console.log({ value });
    let day = date.day;
    let month = date.month;
    let year = date.year;
    const dateAr = [day, month, year];
    if (type == "day") {
      dateAr[0] = value;
    }
    if (type == "month") {
      dateAr[1] = value;
    }
    if (type == "year") {
      dateAr[2] = value;
    }

    const dateString = dateAr.join("-");

    setDate({ ...date, [type]: value });
    console.log(dateString);
    onValueChange(dateString);
  };

  useEffect(() => {
    if (defaultValue) {
      const dateSplit = defaultValue.split("-");
      const day = dateSplit[0] || "";
      const month = dateSplit[1] || "";
      const year = dateSplit[2] || "";
      setDate({
        day,
        month,
        year,
      });
    }
  }, [defaultValue]);

  return (
    <div className="row">
      <div className="col-4">
        <NormalSelect
          value={date.day}
          onchange={(e) => handleChange("day", e.target.value)}
          list={days}
          name="name"
          full
          defaultValueText="- Select Day -"
        />
      </div>

      <div className="col-4">
        <NormalSelect
          value={date.month}
          onchange={(e) => handleChange("month", e.target.value)}
          list={months}
          full
          name="name"
          defaultValueText="- Select Month -"
        />
      </div>

      <div className="col-4">
        <NormalSelect
          value={date.year}
          onchange={(e) => handleChange("year", e.target.value)}
          list={years}
          name="name"
          full
          defaultValueText="- Select Year -"
        />
      </div>
    </div>
  );
};
